import React, { useState } from 'react';
import { Pencil, X } from 'lucide-react';

// Participants Innowide (ils lisent le transcript) et invités externes venus de l'agenda.
const MeetingParticipants = ({ meeting, employees, onSave }) => {
  const [editing, setEditing] = useState(false);
  const [error, setError] = useState(null);
  const ids = meeting.participants.map((p) => p.id);
  const addable = employees.filter((e) => !ids.includes(e.id));

  const save = async (next) => {
    setError(null);
    try {
      await onSave({ participant_ids: next });
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="mt-1 text-xs text-slate-500">
      <div className="flex flex-wrap items-center gap-1.5">
        <span>Participants :</span>
        {meeting.participants.map((p) => (
          <span key={p.id} className={`flex items-center gap-1 rounded-full px-2 py-0.5 ${editing ? 'bg-blue-50 text-blue-700' : 'text-slate-600'}`}>
            {p.name}
            {editing && p.id !== meeting.created_by_employee && (
              <button type="button" onClick={() => save(ids.filter((id) => id !== p.id))} aria-label={`Retirer ${p.name}`}>
                <X className="h-3 w-3" />
              </button>
            )}
          </span>
        ))}
        {editing && (
          <select value="" onChange={(e) => e.target.value && save([...ids, Number(e.target.value)])}
            className="rounded-md border border-slate-200 px-1.5 py-0.5 text-xs">
            <option value="">+ Ajouter…</option>
            {addable.map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}
          </select>
        )}
        {meeting.can_edit && (
          <button type="button" onClick={() => setEditing(!editing)}
            className="ml-1 flex items-center gap-1 text-slate-400 hover:text-blue-600">
            {editing ? 'Terminé' : <><Pencil className="h-3 w-3" /> Modifier</>}
          </button>
        )}
      </div>
      {meeting.external_attendees?.length > 0 && (
        <p className="mt-1">Invités externes : {meeting.external_attendees.map((a) => a.name || a.email).join(', ')}</p>
      )}
      {editing && <p className="mt-1 text-slate-400">Les participants peuvent lire le transcript complet.</p>}
      {error && <p className="mt-1 text-rose-600">{error}</p>}
    </div>
  );
};

export default MeetingParticipants;
